module.exports = __webpack_public_path__ + "static/media/scania.d3e884ae.png";